export default {
  SUCCESS: 0,
  FAIL: 1,
  INFO: 2
};



// WEBPACK FOOTER //
// ./src/components/common/message-box/MessageType.js